import { UploadedFile } from '../types';

export const processFileAsImage = (file: File) =>
  new Promise<UploadedFile>((resolve, reject) => {
    try {
      const image = new Image();
      const imageObjectUrl = window.URL.createObjectURL(file);

      image.src = imageObjectUrl;
      image.onload = () => {
        const uploadedFile: UploadedFile = {
          fileBlob: imageObjectUrl,
          filename: file.name,
          fileSize: file.size,
          height: image.naturalHeight,
          width: image.naturalWidth,
        };
        resolve(uploadedFile);
      };

      image.onerror = () => {
        reject('Invalid image. Please select an image file.');
      };
    } catch (e) {
      reject(e);
    }
  });
